import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
import { ExpenseReport } from '../../models/expenseReport/expenseReport';
const FUNCTION_CODE = 'GET_ALL_EXPENSE_REPORTS';

type GetAllExpenseReportsResponse = {
    count: number;
    next: string | null;
    previous: string | null;
    results: ExpenseReport[];
}

export async function getAllExpenseReports(
    userToken: string,
    params: string,
    page: number
): Promise<GetAllExpenseReportsResponse> {
    try {
        const response = await axios.get(
            `${URL}/expense-reports/?page=${page}${params}`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userToken}`
                }
            },
        );

        return response.data;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur de récuperation de la liste des notes de frais',
            error: error
        });
    }
}
